import { Pagination, Spin } from 'antd'
import React from 'react'
import styled from 'styled-components'

import { AgentInsightCard } from 'features/trend-detection/features/insight-agent/components/AgentInsightCard/AgentInsightCard'
import type { AgentInsightFeedItem } from 'features/trend-detection/features/insight-agent/types'

export interface AgentInsightFeedViewProps {
  items: AgentInsightFeedItem[]
  totalCount: number
  page: number
  isLoading: boolean
  onPageChange: (page: number) => void
  onInsightClick: (insight: AgentInsightFeedItem) => void
}

/** Pure render: the insight-agent feed list. */
export const AgentInsightFeedView: React.FC<AgentInsightFeedViewProps> = ({
  items,
  totalCount,
  page,
  isLoading,
  onPageChange,
  onInsightClick,
}) => {
  if (isLoading) {
    return (
      <Centered>
        <Spin />
      </Centered>
    )
  }

  if (items.length === 0) {
    return (
      <Centered>
        <EmptyTitle>No insights yet</EmptyTitle>
        <EmptyBody>
          Create an insight agent and run it — its insights land here.
        </EmptyBody>
      </Centered>
    )
  }

  return (
    <FeedList>
      {items.map((insight) => (
        <AgentInsightCard
          key={insight.uuid}
          insight={insight}
          onClick={onInsightClick}
        />
      ))}
      {totalCount > items.length && (
        <PaginationRow>
          <Pagination
            current={page}
            total={totalCount}
            pageSize={15}
            showSizeChanger={false}
            onChange={onPageChange}
          />
        </PaginationRow>
      )}
    </FeedList>
  )
}

const FeedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const Centered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 48px 24px;
  text-align: center;
`

const EmptyTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #28364f;
`

const EmptyBody = styled.div`
  font-size: 14px;
  color: #717680;
`

const PaginationRow = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 0;
`
